"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FullScreenLoader = _interopRequireDefault(require("../../../IconicDisplayElements/FullScreenLoader"));

var _propTypes2 = _interopRequireDefault(require("../../../../constants/propTypes"));

var _getComponent = _interopRequireDefault(require("../../../../utils/getComponent"));

var _layout = require("../../../../styles/2_commonComponentStyles/layout");

var _LayoutOneCol = require("./LayoutOneCol.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * LayoutOneCol - One column layout wrapper component
 * including header, progressBar, content and footer
 *
 * ***Black rootBorders have been provided for illustrative purposes***
 *
 * ***The box shadow shows all the way around the top menu because normally the window would trim that off***
 */
var LayoutOneCol = function LayoutOneCol(_ref) {
  var className = _ref.className,
      children = _ref.children,
      colorTheme = _ref.colorTheme,
      doneLoading = _ref.doneLoading,
      doneLoadingMessage = _ref.doneLoadingMessage,
      isLoading = _ref.isLoading,
      loaderMessage = _ref.loaderMessage,
      _inStyleGuide = _ref._inStyleGuide,
      props = _objectWithoutProperties(_ref, ["className", "children", "colorTheme", "doneLoading", "doneLoadingMessage", "isLoading", "loaderMessage", "_inStyleGuide"]);

  return (
    /*#__PURE__*/
    // header is placed above teh progress par via styles but since they are placed via 'fixed' on mobile,
    // header must come after progress bar for correct layering.
    _react.default.createElement(_LayoutOneCol.StyledLayoutOneColumn, _extends({}, props, {
      colorTheme: colorTheme,
      className: className
    }), /*#__PURE__*/_react.default.createElement(_FullScreenLoader.default, {
      dataTestId: "layout-one-col-loader",
      doneLoading: doneLoading,
      doneLoadingMessage: doneLoadingMessage,
      loading: isLoading,
      message: loaderMessage,
      _inStyleGuide: true
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: ['c-layout-one-col-header', _inStyleGuide ? 'c-layout-one-col-remove-fixed' : null].join(' ')
    }, (0, _getComponent.default)('header', children)), /*#__PURE__*/_react.default.createElement("div", {
      className: ['c-layout-one-col-progress-bar', _inStyleGuide ? 'c-layout-one-col-remove-fixed' : null].join(' ')
    }, (0, _getComponent.default)('progressBar', children)), /*#__PURE__*/_react.default.createElement("div", {
      className: ['c-layout-one-col-nav-area', isLoading || doneLoading ? 'c-layout-one-col-blur' : undefined, _inStyleGuide ? 'c-layout-one-col-remove-fixed' : null].join(' ')
    }, (0, _getComponent.default)('navArea', children)), /*#__PURE__*/_react.default.createElement("div", {
      className: ['c-layout-one-col-content', isLoading || doneLoading ? 'c-layout-one-col-blur' : undefined].join(' ')
    }, (0, _getComponent.default)('content', children)), /*#__PURE__*/_react.default.createElement("div", {
      className: ['c-layout-one-col-footer', isLoading || doneLoading ? 'c-layout-one-col-blur' : undefined].join(' ')
    }, (0, _getComponent.default)('footer', children)))
  );
};

LayoutOneCol.propTypes = {
  /** Collection of items to be slotted into the content containers.
   * <br />Valid child keys are are: header, progressBar, content & footer.
   * <br/>Children can be any valid node or array of valid nodes.
   */
  children: _propTypes2.default.children,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,
  // dataTestId is intentionally omitted from this class as it is just a wrapper

  /** (optional) Indicates if loading has finished as a precursor to showing doneLoadingMessage */
  doneLoading: _propTypes.default.bool,

  /** (optional) Message to show for loading completion screen */
  doneLoadingMessage: _propTypes.default.string,

  /** flag to indicate loading state */
  isLoading: _propTypes.default.bool,

  /** flag for overriding the body color - `undefined` or `alt` */
  colorTheme: _propTypes.default.oneOf(_layout.layoutColorThemes),

  /** message to display in the loader when visible */
  loaderMessage: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]),

  /** a flag specifically for the styleguide - used to turn off fixed positioning */
  _inStyleGuide: _propTypes.default.bool
};
LayoutOneCol.defaultProps = {
  children: undefined,
  className: '',
  doneLoading: false,
  doneLoadingMessage: undefined,
  isLoading: false,
  loaderMessage: undefined,
  _inStyleGuide: false,
  colorTheme: 'default'
};
var _default = LayoutOneCol;
exports.default = _default;